module.exports = __webpack_public_path__ + "dfac39708f043d69d7bfa19232965dd3.png";